module.exports = __webpack_public_path__ + "static/media/grangeroutside.35672483.jpg";